import React, { useState, useEffect } from "react";
import "./GoldChart.css";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import { useSelector } from "react-redux";
const TimeFrame = {
  Last15Days: 0,
  Last1Month: 1,
  Last6Months: 2,
};
const GoldChart = () => {
  const [data, setData] = useState([]);
  const [timeFrame, setTimeFrame] = useState(process.env.CHART_RANGE || TimeFrame.Last6Months);
  const accessToken = useSelector((state) => state.auth.accessToken);
  const fetchData = async (range) => {
    console.log(`Fetching data for range enum: ${range}`);
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}PriceHistory/${range}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (!response.ok) throw new Error("Failed to fetch data");
      const result = await response.json();
      const sortedData = result.sort((a, b) => new Date(a.date) - new Date(b.date));
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData(timeFrame);
  }, [timeFrame]);
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return timeFrame === TimeFrame.Last6Months
      ? date.toLocaleDateString("en-GB", { month: "long" })
      : date.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
  };
  const getUniqueMonths = (data) => {
    const seen = new Set();
    return data.filter((entry) => {
      const month = formatDate(entry.date);
      if (seen.has(month)) {
        return false;
      }
      seen.add(month);
      return true;
    });
  };
  const filteredData = timeFrame === TimeFrame.Last6Months ? getUniqueMonths(data) : data;
  const chartData = {
    labels: filteredData.map((entry) => formatDate(entry.date)),
    datasets: [
      {
        label: "Gold Price",
        data: filteredData.map((entry) => entry.prices),
        borderColor: "#FFC000",
        backgroundColor: "#FFC000",
        fill: false,
        tension: 0.4,
      },
    ],
  };
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
     
      legend: {
        display: false 
    },
    title: {
        display: false 
    }
    },
    layout: {
      padding: {
        left: 10,
        right: 20,
        top: 20,
        bottom: 10
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Duration",
          color: "#FFFFFF",
          font: {
            size: 16,
            weight: "bold",
          },
        },
        ticks: {
          maxRotation: timeFrame === TimeFrame.Last15Days ? 0 : 90, 
          minRotation: timeFrame === TimeFrame.Last15Days ? 0 : 90,
          color: "#FFFFFF",
          font: {
            size: 14,
            weight: "bold",
          },
        },
        grid: {
          color: "#76527A",
        },
      },
      y: {
        title: {
          display: true,
          text: "Price",
          color: "#FFFFFF", 
          font: {
            size: 16,
            weight: 'bold'
          }
        },
        ticks: {
          color: "#FFFFFF",
          font: {
            size: 16,
            weight: 'bold'
          },
        },
        grid: {
          color: "#76527A", 
        },
        suggestedMin: 6000,
        suggestedMax: 10000,
      },
    },
  };
  return (
    <div className="gold-chart-container">
      <div className="gold-rate-text-out">
        <p className="card-title m-0">Gold Rate</p>
        <div className="duration-selection-outer">
          <div className="duration-section">
            <select 
              className="dropdown-select" 
              value={timeFrame}
              onChange={(e) => {
                const selectedValue = Number(e.target.value);
                console.log("Selected TimeFrame:", selectedValue); 
                setTimeFrame(selectedValue);
              }}
            >
              <option value={TimeFrame.Last15Days}>Last 15 Days</option>
              <option value={TimeFrame.Last1Month}>Last 1 Month</option>
              <option value={TimeFrame.Last6Months}>Last 6 Months</option>
            </select>
          </div>
        </div>
      </div>
      <Line data={chartData} options={chartOptions} />
    </div>
  );
};
export default GoldChart;
